import { counterPartyModel, CounterPartyType, portModel } from 'model';
import { createContext } from 'react';

interface CounterPartySelectorContextProps {
  counterParty?: Partial<counterPartyModel>;
  port?: Partial<portModel>;
  allowAdd?: boolean;
  counterPartyType: CounterPartyType;
  onChange: (counterParty?: Partial<counterPartyModel>) => void;
  disablePortFilter?: boolean;
  disableCountryFilter?: boolean;
}

const CounterPartySelectorContext = createContext<CounterPartySelectorContextProps>({
  onChange: () => {},
  counterPartyType: 'ALL'
});

export default CounterPartySelectorContext;
